<div class="card o-hidden">
   <div class="card-header">
     <h5>{{ 'Monthly  History' | translate }}</h5>
   </div>
   <div class="bar-chart-widget">
     <div class="bottom-content card-body">
       <div class="row">
         <div class="col-12">
           <div id="chart-widget4">
               <apx-chart [series]="monthlyHistory.series" [chart]="monthlyHistory.chart" [plotOptions]="monthlyHistory.plotOptions" [dataLabels]="monthlyHistory.dataLabels" [stroke]="monthlyHistory.stroke" [xaxis]="monthlyHistory.xaxis" [yaxis]="monthlyHistory.yaxis" [colors]="monthlyHistory.colors" [fill]="monthlyHistory.fill" [tooltip]="monthlyHistory.tooltip" [responsive]="monthlyHistory.responsive"></apx-chart>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>